import { GetApiArbitragesParams, useGetApiArbitrages } from '@/api';
import { USER_TYPE } from '@/enums/userType';
import { useAuth } from '@/hooks/useAuth';

const useArbitrages = (params?: GetApiArbitragesParams, options?: { query?: { enabled?: boolean } }) => {
  const { user } = useAuth();

  return useGetApiArbitrages(params, {
    query: {
      ...options?.query,
      enabled: user?.type === USER_TYPE.client && (options?.query?.enabled ?? true),
    },
  });
};

export { useArbitrages };
